import React from 'react';

import { Button } from 'antd';

import { allowPermission } from 'utils/permission';

interface IComponentProps {
	permissionKey?: any;
	permission?: any;
	children?: any;
	type?: any;
	onClick?: any;
	[key: string]: any;
}
const SPButton: React.FC<IComponentProps> = props => {
	const { permissionKey, permission, children, ...cmpProps } = props;

	if (!permissionKey) {
		return <Button {...cmpProps}>{children}</Button>;
	} else if (!allowPermission(String(permissionKey), permission)) {
		return null
	}

	return <Button {...cmpProps}>{children}</Button>;
};

export default SPButton;
